import { mapGetters } from 'vuex'

export default {
  name: 'TourLauncherMixin',

  data () {
    return {
      // OLDTOUR showToursDialog: null
      showToursDialog: false,
      showToursDialogTitle: this.$t('label.showTours')
    }
  },

  computed: {
    ...mapGetters({
      tour: 'tourStore/tour',
      tours: 'tourStore/tours',
      userShowTours: 'userDataStore/showTours',
      userTours: 'userDataStore/userTours'
    }),

    dialogTitle () {
      let title = this.$t(this.showToursDialogTitle)
      if (Array.isArray(title)) {
        title = title.join(`\r\n`)
      }
      return title
    }
  },

  methods: {
    handleShowTourYes () {
      this.showToursDialog = false
      this.$store.commit('userDataStore/setShowTours', true)
    },
    handleShowTourNo () {
      this.showToursDialog = false
      this.$store.commit('userDataStore/setShowTours', false)
    }
  },

  watch: {
    tour (val, prevVal) {
      if (val && prevVal === undefined && this.showToursDialog === null) {
        this.showToursDialog = true
        this.showToursDialogTitle = val.showTour ? val.showTour : 'label.showTours'
      }
    }
  }
}
